import { render, staticRenderFns } from "./AutobuyerIntervalButton.vue?vue&type=template&id=3a56a57e&scoped=true&"
import script from "./AutobuyerIntervalButton.vue?vue&type=script&lang=js&"
export * from "./AutobuyerIntervalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56a57e",
  null
  
)

export default component.exports